/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFontDestroy } from '../../axios/customFontDestroy'
import type {
	CustomFontDestroyError,
	CustomFontDestroyPathParams,
	CustomFontDestroyResponse,
} from '../../types/CustomFontDestroy'

export const customFontDestroyMutationKey = () => [{ url: '/organisations/:organisation/fonts/:media' }] as const

export type CustomFontDestroyMutationKey = ReturnType<typeof customFontDestroyMutationKey>

export type CustomFontDestroyVariables = {
	organisation: CustomFontDestroyPathParams['organisation']
	media: CustomFontDestroyPathParams['media']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/CustomFontController.php CustomFontController::destroy */
export function useCustomFontDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CustomFontDestroyResponse,
		AxiosError<CustomFontDestroyError>,
		CustomFontDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: customFontDestroyMutationKey(),
		mutationFn: ({ organisation, media }: CustomFontDestroyVariables) =>
			customFontDestroy(organisation, media, config).then(res => res.data),
		...options,
	})
}
